export const socialLinks = [
	{
		id: 1,
		name: 'GitHub',
		icon: 'github',
		url: 'https://github.com/yciolk',
	},
	{
		id: 2,
		name: 'LinkedIn',
		icon: 'linkedin',
		url: 'https://www.linkedin.com/in/yann-ciolkowski-92675120a/',
	},
	{
		id: 3,
		name: 'YouTube',
		icon: 'youtube',
		url: 'https://www.youtube.com/@Dev1454',
	},
];
